import { libraryManagedConfig } from '../../../../config';
import { http } from '../../../../api/axios';
import { ProductOut } from '../../../../store/api';

export const fetchLibraryMangedProductGroupProducts = async (
    productGroupIds: number[]
): Promise<{ [key: string]: ProductOut[] }> => {
    const productGroupsResponse = productGroupIds.map(async productGroupId => {
        const response = await http.post(
            libraryManagedConfig().endpointProductGroupProducts,
            {},
            {
                params: { pageSize: 20, skipRuntimeDuplicationCheck: true },
                pathParams: { productGroupId: productGroupId?.toString() }
            }
        );

        return { [productGroupId.toString()]: response.data.hits };
    });

    let result = await Promise.all(productGroupsResponse);

    return result.reduce((acc, curr) => {
        return { ...acc, ...curr };
    }, {});
};
